<template>
<div class="chapter">
<div class="inner_page">
<p class="fig"><img alt="image" src="images/pg3.jpg"/></p>
<p class="Caption1">Autumn Buttons Bracelet</p>
<div class="orang">
<p class="ackhd1">MY BIGGEST FANS</p>
<p class="ackc">To my husband, Kevin, and daughter, Gwen—thank you for your unconditional love and support and for allowing me to play in my room.</p>
<p class="ackc">With love, me</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Fm_big.vue?820843da